import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';

export default function NotificationList() {
  const { notifications, removeNotification } = useNotifications();

  if (!notifications.length) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {notifications.map(n => (
        <div key={n.id} className="bg-gray-800 text-white px-4 py-2 rounded shadow flex items-center gap-3">
          <span className="flex-1 text-sm">{n.message}</span>
          {n.actionLabel && (
            <button
              onClick={() => { n.onAction?.(); removeNotification(n.id); }}
              className="text-sm px-2 py-1 bg-purple-600 rounded hover:bg-purple-500"
            >
              {n.actionLabel}
            </button>
          )}
          {!n.actionLabel && (
            <button onClick={() => removeNotification(n.id)} className="text-sm px-2">✕</button>
          )}
        </div>
      ))}
    </div>
  );
}
